import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'devextreme-react/button';
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
//devextreem
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import {
  /* NumberBox, */
  TextArea,
} from 'devextreme-react';

import { RootStore } from 'bus/configureStore';
import { asyncNomenclatureCreate } from 'bus/nomenclature/actions';
import { NomenclatureItemCreate } from 'bus/nomenclature/types';

//type TempArrayItem = {name: string; materialId: number; quantity: number | undefined}

type DetailModalRoleProps = {
  refresh: () => void;
};

const DetailModalRole: FC<DetailModalRoleProps> = (props) => {
  const dispatch = useDispatch();
  const storeNomenclature = useSelector((store: RootStore) => store.nomenclature);

  const [form, setForm] = useState<NomenclatureItemCreate>({
    name: '',
    printName: '',
    comment: '',
    compositions: [],
    isDeleted: false,
  });

  //const [tempCompositions, setTempCompositions] = useState<Array<TempArrayItem>>([])

  const [visible, setVisible] = useState<boolean>(false);
  let createCatalogRoleValidRef = useRef<ValidationGroup | null>(null);
  let createCatalogRoleRef = useRef<any>(null);

  const handleSubmit = (e: any) => {
    e.preventDefault && e.preventDefault();
    if (createCatalogRoleValidRef.current?.instance.validate().isValid) {
      let tempForm: any = { ...form /* , compositions: tempCompositions */ };
      dispatch(asyncNomenclatureCreate(tempForm));
    }
  };

  //слушатели для закрытия окна
  useEffect(() => {
    if (storeNomenclature.nomenclatureListCreate.data) {
      setVisible(false);
      props.refresh();
      createCatalogRoleRef.current.instance.resetValues();
      createCatalogRoleValidRef.current?.instance.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeNomenclature.nomenclatureListCreate.data]);

  const onShown = () => {};

  const onHiden = () => {};

  return (
    <div>
      <Button width={120} text="Создать" type="default" onClick={() => setVisible(true)} />

      <Popup
        visible={visible}
        onHiding={() => setVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Добавление рецепта"
        width={400}
        onShowing={() => onShown()}
        onHidden={() => onHiden()}
        height={'auto'}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">
              <ValidationGroup ref={createCatalogRoleValidRef}>
                <Form formData={form} ref={createCatalogRoleRef}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppFiledBox label="Наименование" labelTop>
                      <TextBox
                        stylingMode="underlined"
                        placeholder="Наименование"
                        mode="text"
                        value={form.comment}
                        onValueChange={(e: any) => {
                          setForm((prev: any) => ({ ...prev, comment: e }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле Наименование" />
                        </Validator>
                      </TextBox>
                    </AppFiledBox>

                    <AppFiledBox label="Марка" labelTop>
                      <TextBox
                        stylingMode="underlined"
                        placeholder="Марка"
                        mode="text"
                        value={form.name}
                        onValueChange={(e: any) => {
                          setForm((prev: any) => ({ ...prev, name: e }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле Марки" />
                        </Validator>
                      </TextBox>
                    </AppFiledBox>

                    <AppFiledBox label="Марка на печать" labelTop>
                      <TextBox
                        stylingMode="underlined"
                        placeholder="Марка на печать"
                        mode="text"
                        value={form.printName}
                        onValueChange={(e: any) => {
                          setForm((prev: any) => ({ ...prev, printName: e }));
                        }}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле марка на печать" />
                        </Validator>
                      </TextBox>
                    </AppFiledBox>

                    <div>
                      {/* {
                                            tempCompositions.map((item, index) => {
                                                return (
                                                    <AppFiledBox
                                                        label={item.name}

                                                    >
                                                        <NumberBox
        stylingMode='underlined'
                                                            placeholder="0"
                                                            //mode="text"
                                                            value={item.quantity}
                                                            onValueChange={(e: any) =>{
                                                                let temp = [...tempCompositions]
                                                                temp[index].quantity = e
                                                                setTempCompositions(temp)
                                                            }}
                                                        />
                                                    </AppFiledBox>
                                                )
                                            })

                                        } */}
                    </div>
                  </Item>
                </Form>
                <ModalFooter
                  handleSubmit={handleSubmit}
                  hideModal={() => setVisible(false)}
                  useSubmitBehavior={false}
                />
              </ValidationGroup>
            </div>
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalRole;
